import React, { useState, useRef, useEffect } from "react";
//naviagte import
import { useNavigate } from "react-router-dom";
// import { FaArrowLeft, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { FaHeart, FaRegCommentDots, FaEllipsisH } from "react-icons/fa";
// CSS For Wallet
import "../css/Savedposts.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCreditCard,
    faBell,
    faCommentDots,
    faUser,
    faCog,
    faStar,
    faVideo,
    faUsers,
    faSignOutAlt,
    faQuestionCircle,
    faCircleCheck,


} from "@fortawesome/free-solid-svg-icons";
// Import Iconify for icons
import { Icon } from "@iconify/react";
// import Navbar from "./Navbar";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function Savedposts() {
    // for top tabs functionality
    const [activeTab, setActiveTab] = useState("forYou");
    //navigate page
    const navigate = useNavigate();
    // for prime public button click 

    // for sidebar buttons
    const [activeSidebar, setActiveSidebar] = useState("prime");
    //msg
    const [showMsgDrawer, setShowMsgDrawer] = useState(false);
    // for menu toggle functionality
    const [showSidebar, setShowSidebar] = useState(true);
    // profile settings
    const [showProfile, setShowProfile] = useState(false);
    const profileRef = useRef(null);
    // modal 
    const [modal, setModal] = useState(false);
    //msg tab acitivate
    // const [activeTab, setActiveTab] = useState("all");

    const toggle = () => setModal(!modal);
    //  const [showModal, setShowModal] = useState(false);
    // const [showModal, setShowModal] = useState(false);
    // Close popup when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (profileRef.current && !profileRef.current.contains(e.target)) {
                setShowProfile(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    //naviagte profile page
    const goToProfile = () => {
        navigate("/profile");
    };

    //profile lock
    const toggleProfileLock = () => {
        setIsProfileLocked(prev => !prev);
    };
    const [isProfileLocked, setIsProfileLocked] = useState(false);



    //logout 

    const handleLogout = () => {
        const confirmLogout = window.confirm("Are you sure you want to logout?");//alert for confirmation

        if (confirmLogout) {
            //clear everything
            // localStorage.clear();

            //Redirect to login page
            navigate("/login");
        }
    };

    const posts = [
        {
            id: 1,
            userName: "Shivansh Shrivastav",
            time: "Dec 26, 2025 11:30 AM",
            text: "fefgergergerg",
            image: "/images/chillipaneer.jpg"
        },
        {
            id: 2,
            userName: "Shivansh Shrivastav",
            time: "Dec 26, 2025 11:30 AM",
            text: null,
            image: "/images/chillipaneer.jpg"
        },
        {
            id: 3,
            userName: "Shivansh Shrivastav",
            time: "Dec 26, 2025 11:30 AM",
            text: "Another post",
            image: "/images/chillipaneer.jpg"
        },
        {
            id: 4,
            userName: "Shivansh Shrivastav",
            time: "Dec 26, 2025 11:30 AM",
            text: "Another post",
            image: "/images/chillipaneer.jpg"
        }
    ];


    // profile edit change icon
    const openFilePicker = () => {
        fileInputRef.current.click();
    };
    const fileInputRef = useRef(null);
    const handleQuickImageChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const base64 = await fileToBase64(file);

        setProfileImage(base64);
        localStorage.setItem("profileImage", base64);
    };


    // cover image change for icon
    const openCoverPicker = () => {
        coverInputRef.current.click();
    };

    const handleCoverChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const base64 = await fileToBase64(file);

        setCoverImage(base64);
        localStorage.setItem("coverImage", base64);
    };

    const coverInputRef = useRef(null);
    // const [coverImage, setCoverImage] = useState("/images/Coverpage.jpg");

    //Resfresh profile image and cover image
    const fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
        });


    //   usestate for resfresh
    useEffect(() => {
        const savedProfile = localStorage.getItem("profileImage");
        const savedCover = localStorage.getItem("coverImage");

        if (savedProfile) setProfileImage(savedProfile);
        if (savedCover) setCoverImage(savedCover);
    }, []);

    // initial updated
    const [profileImage, setProfileImage] = useState(
        localStorage.getItem("profileImage") || "/images/profileimg.png"
    );

    const [coverImage, setCoverImage] = useState(
        localStorage.getItem("coverImage") || "/images/Coverpage.jpg"
    );
    return (
        <div className="container page-wrapper">
            <div className="page-top-container">
                <nav className="navbar top-header">

                    {/* -----------company Logo------------ */}
                    <div
                        className="company-logo"
                        onClick={() => setShowSidebar(prev => !prev)}
                    >
                        <img src="/images/logo1.jpg" alt="logo1" />
                    </div>

                    {/*  */}

                    <div className="search-box">
                        <i className="prime-search-icon"><Icon icon="ic:sharp-search" /></i>
                        <input
                            type="text"
                            placeholder="Search Politics , Parties and Leadership"
                        />
                    </div>


                    <div className="global-icons d-flex gap-0 gap-md-2 align-items-center">

                        {/* Wallet */}
                        {/* <span className="position-relative border-0">
                            <FontAwesomeIcon icon={faCreditCard} className="icon-box" />
                            <span className="global-creditCard-data position-absolute translate-middle badge rounded-pill bg-danger">
                                <Icon icon="ic:sharp-currency-rupee" />50
                            </span>
                        </span> */}
                        <span
                            className="position-relative border-0 cursor-pointer"
                            onClick={() => navigate("/wallet")}
                        >
                            <FontAwesomeIcon
                                icon={faCreditCard}
                                className="icon-box"
                            />

                            <span className="global-creditCard-data position-absolute translate-middle badge rounded-pill bg-danger">
                                <Icon icon="ic:sharp-currency-rupee" /> 50
                            </span>
                        </span>

                        {/*----------------------- Notification---------------------- */}

                        <span
                            className="position-relative border-0 bell-icon"
                            style={{ cursor: "pointer" }}
                            onClick={toggle}
                        >
                            <FontAwesomeIcon icon={faBell} className="icon-box" />
                            {/* <span className="global-bell-data badge bg-danger">5</span> */}
                        </span>

                        {/* Reactstrap Modal */}
                        <Modal isOpen={modal} toggle={toggle} centered>
                            <ModalHeader toggle={toggle}>
                                Notifications
                            </ModalHeader>

                            <ModalBody>
                                <p>Your post received new likes.</p>
                                <small className="text-muted">2 days ago</small>

                                <hr />

                                <p>
                                    Learn how Meta will use your info in new ways to personalize your
                                    experience.
                                </p>
                                <small className="text-muted">9 weeks ago</small>
                            </ModalBody>

                            <ModalFooter>
                                <Button color="secondary" onClick={toggle}>
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>

                        {/* ----------------------------Profile ---------------------------------- */}

                        <span
                            className="position-relative border-0 msg-icon"
                            onClick={() => setShowMsgDrawer(true)}
                        >
                            <FontAwesomeIcon icon={faCommentDots} className="icon-box" />
                        </span>


                        {/* PROFILE ICON */}
                        <div className="position-relative" ref={profileRef}>
                            <FontAwesomeIcon
                                icon={faUser}
                                className="icon-box profile-icon"
                                onClick={() => setShowProfile(!showProfile)}
                            />

                            {/* PROFILE POPUP */}
                            {showProfile && (
                                <div className="profile-popup">

                                    {/* Profile Card */}
                                    <div className="profile-card">
                                        <div className="profile-header">
                                            <div className="avatar">
                                                <FontAwesomeIcon icon={faUser} />
                                            </div>
                                            <span className="username">Helena king</span>
                                        </div>

                                        <div className="divider"></div>

                                        <button
                                            className="see-profile-btn"
                                            onClick={() => navigate("/profile")}
                                        >
                                            <FontAwesomeIcon icon={faUsers} /> My Profile
                                        </button>

                                    </div>

                                    {/* Menu Items */}
                                    <div className="profile-popup-item">
                                        <FontAwesomeIcon icon={faCog} />
                                        <span>Settings & privacy</span>
                                        {/* <span className="arrow">›</span> */}
                                    </div>

                                    <div className="profile-popup-item">
                                        <FontAwesomeIcon icon={faQuestionCircle} />
                                        <span>Help & support</span>
                                        {/* <span className="arrow">›</span> */}
                                    </div>

                                    <div
                                        className="profile-popup-item logout"
                                        onClick={handleLogout}
                                    >
                                        <FontAwesomeIcon icon={faSignOutAlt} />
                                        <span>Logout</span>
                                    </div>

                                    {/* Footer */}
                                    <div className="popup-footer">
                                        Privacy · Terms · Advertising · Ad Choices · Cookies · More
                                    </div>
                                </div>
                            )}
                        </div>


                    </div>
                </nav>
            </div>

            {/* ----------------------------------Msg Drawer-------------------------------------- */}
            {showMsgDrawer && (
                <>
                    <div
                        className="msg-overlay"
                        onClick={() => setShowMsgDrawer(false)}
                    ></div>

                    <div className="msg-drawer">
                        <div className="msg-header">
                            <h3>Chats</h3>
                            <span onClick={() => setShowMsgDrawer(false)}>✕</span>
                        </div>

                        <div className="msg-search">
                            <input placeholder="Search Messenger" />
                        </div>

                        {/* <div className="msg-tabs">
                            <span className="active">All</span>
                            <span>Unread</span>
                            <span>Groups</span>
                            <span>Communities</span>
                        </div> */}
                        <div className="msg-tabs">
                            <span
                                className={activeTab === "all" ? "active" : ""}
                                onClick={() => setActiveTab("all")}
                            >
                                All
                            </span>

                            <span
                                className={activeTab === "unread" ? "active" : ""}
                                onClick={() => setActiveTab("unread")}
                            >
                                Unread
                            </span>

                            <span
                                className={activeTab === "groups" ? "active" : ""}
                                onClick={() => setActiveTab("groups")}
                            >
                                Groups
                            </span>

                            <span
                                className={activeTab === "communities" ? "active" : ""}
                                onClick={() => setActiveTab("communities")}
                            >
                                Communities
                            </span>
                        </div>

                        <div className="msg-empty">
                            <h4>No chats</h4>
                            <p>When you have chats, you’ll see them here..</p>
                        </div>

                        <div
                            className="msg-footer"
                            onClick={() => {
                                setShowMsgDrawer(false);
                                navigate("/message");
                            }}
                        >
                            See all in Messenger
                        </div>
                    </div>
                </>
            )}
            {/* ================= PRIME LAYOUT CONTAINER ================= */}
            <div className="prime-layout">
                <div className="prime-row">

                    {/* <div
                        className={`sidebar-container col-lg-3 col-md-3 d-md-block ${showSidebar ? "sidebar-hide" : "sidebar-show"} `}
                    >
                        <aside className="sidebar">
                            <ul className="left-menu">

                                <li
                                    className={activeSidebar === "prime" ? "menu-item active" : "menu-item"}
                                    onClick={() => {
                                        setActiveSidebar("prime");
                                        navigate("/prime");
                                    }}
                                >
                                    <FontAwesomeIcon icon={faStar} /> Prime
                                </li>

                                <li
                                    className={activeSidebar === "public" ? "menu-item active" : "menu-item"}
                                    onClick={() => {
                                        setActiveSidebar("public");
                                        navigate("/public");
                                    }}
                                >
                                    <FontAwesomeIcon icon={faUsers} /> Public
                                </li>

                                <li
                                    className={activeSidebar === "revolution" ? "menu-item active" : "menu-item"}
                                    onClick={() => {
                                        setActiveSidebar("revolution");
                                        navigate("/revolution");
                                    }}
                                >
                                    <FontAwesomeIcon icon={faVideo} /> Revolution
                                </li>

                                <li
                                    className={activeSidebar === "wallet" ? "menu-item active" : "menu-item"}
                                    onClick={() => {
                                        setActiveSidebar("wallet");
                                        navigate("/wallet");
                                    }}
                                >
                                    <FontAwesomeIcon icon={faCreditCard} /> Wallet
                                </li>

                                <li
                                    className={activeSidebar === "profile" ? "menu-item active" : "menu-item"}
                                    onClick={() => {
                                        setActiveSidebar("profile");
                                        navigate("/verified");
                                    }}
                                >
                                    <FontAwesomeIcon icon={faCircleCheck} /> Verified
                                </li>

                                <li
                                    className={activeSidebar === "settings" ? "menu-item active" : "menu-item"}
                                    onClick={() => {
                                        setActiveSidebar("settings");
                                        navigate("/profile");
                                    }}
                                >
                                    <FontAwesomeIcon icon={faCog} /> Settings
                                </li>

                            </ul>

                        </aside>
                    </div> */}

                    {/* ---------------------------================= CENTER AREA =================---------- */}
                    <div className="col-md-9 col-12 profile-div">
                        <div className="profile-page">

                            <div
                                className="profile-cover"
                                style={{ backgroundImage: `url(${coverImage})` }}
                            >
                                {/* Cover edit icon */}
                                <div className="cover-image-edit" onClick={openCoverPicker}>
                                    <Icon icon="mdi:camera" width="22" />
                                </div>

                                {/* Hidden file input */}
                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={coverInputRef}
                                    style={{ display: "none" }}
                                    onChange={handleCoverChange}
                                />

                                {/* Profile image */}
                                <div className="profile-image-wrapper">
                                    <img
                                        src={profileImage}
                                        alt="Profile"
                                        className="profile-image"
                                    />

                                    <div className="profile-image-edit" onClick={openFilePicker}>
                                        <Icon icon="mdi:camera" width="20" />
                                    </div>

                                    <input
                                        type="file"
                                        accept="image/*"
                                        ref={fileInputRef}
                                        style={{ display: "none" }}
                                        onChange={handleQuickImageChange}
                                    />
                                </div>
                            </div>


                            {/* ===== Name & Stats ===== */}
                            <div className="profile-info">
                                <h2 className="profile-heading">Helena King</h2>
                                <p className="followers">3 followers</p>
                                <div className="profile-tabs1">

                                    <div
                                        className="tab-card1"
                                        onClick={() => navigate("/posts")}
                                    >
                                        <span>Posts</span>
                                    </div>

                                    <div
                                        className="tab-card1"
                                        onClick={() => navigate("/savedposts")}
                                    >
                                        <span>Saved Posts</span>
                                    </div>

                                    <div className="tab-card1 copy-link">
                                        <span>Share Profile</span>
                                    </div>

                                    {/* 🔐 Profile Lock Toggle Tab */}
                                    <div
                                        className="tab-card1 profile-lock-tab"
                                        onClick={toggleProfileLock}
                                    >
                                        {isProfileLocked ? (
                                            <>
                                                <Icon icon="mdi:lock" width="18" />
                                                <span>Locked</span>
                                            </>
                                        ) : (
                                            <>
                                                <Icon icon="mdi:lock-open-variant" width="18" />
                                                <span>Profile Lock</span>
                                            </>
                                        )}
                                    </div>

                                </div>


                            </div>

                            {/* ===== Main Content ===== */}
                            <div className="profile-layout01">

                                {/* RIGHT SIDE – POSTS */}
                                <div className="posts-grid01">
                                    {posts.map((post) => (
                                        <div className="post-card01" key={post.id}>

                                            <div className="post-header01">
                                                <div className="user-info01">
                                                    <img src="/images/profileimg.png" alt="profile" />
                                                    <div>
                                                        <h4>{post.userName}</h4>
                                                        <span>{post.time}</span>
                                                    </div>
                                                </div>
                                                <FaEllipsisH />
                                            </div>

                                            {post.text && <p className="post-text">{post.text}</p>}

                                            {post.image && (
                                                <img src={post.image} alt="post" className="post-image" />
                                            )}

                                            <div className="post-actions01">
                                                <FaHeart />
                                                <FaRegCommentDots />
                                            </div>

                                        </div>
                                    ))}
                                </div>



                            </div>

                        </div>


                    </div>
                </div>


            </div>
        </div>





    );
}
export default Savedposts;